import React, { useState } from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import { Icon } from '@iconify/react';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import CheckerManualSettlementTable from '../components/CheckerManualSettlementTable';
interface CheckerManualSettlementProps {
  onLogout: () => void;
}
export default function CheckerManualSettlement({
  onLogout
}: CheckerManualSettlementProps) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return <Box sx={{
    display: 'flex',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: 'background.default',
    overflow: 'hidden'
  }} data-id="element-3363" data-mp="227v0zeiznc9u">
      
      <TopBar onMenuClick={handleDrawerToggle} onLogout={onLogout} title="Checker - Manual Settlement" data-id="element-3364" data-mp="1t6wumpl2uso3" />
      
      <Sidebar open={mobileOpen} onClose={handleDrawerToggle} activePage="checker-manual-settlement" data-id="element-3365" data-mp="2q767npi292uk" />
      
      <Box component="main" sx={{
      flexGrow: 1,
      py: 2,
      px: {
        xs: 2,
        sm: 3,
        md: 5
      },
      width: {
        xs: '100%',
        sm: `calc(100% - 240px)`
      },
      maxWidth: '100%',
      ml: 0,
      mt: 8,
      overflow: 'hidden'
    }} data-id="element-3366" data-mp="2v0hgfw6fntp4">
        
        <Box sx={{
        maxWidth: '100%'
      }} data-id="element-3367" data-mp="3dwr2b5nktojo">
          
          <Box sx={{
          display: 'flex',
          alignItems: 'center',
          mb: 2
        }} data-id="element-3368" data-mp="2zwzi2n6gvbx8">
            
            <Icon icon="lucide:stamp" width={28} height={28} color="#0EA5E9" data-id="element-3369" data-mp="1oim0u167xuq6" />
            <Typography variant="h5" component="h1" sx={{
            ml: 1.5,
            fontWeight: 600
          }} data-id="element-3370" data-mp="1okouqwahs806">
              
              Checker Inbox - Manual Settlement
            </Typography>
          </Box>
          <CheckerManualSettlementTable data-id="element-3371" data-mp="3q89y44xzo569" />
        </Box>
      </Box>
    </Box>;
}